import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LeagueIterationService {
    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) { }

    getAllByLeagueId(filter: any): any {
        return this.http.get(`${this.url}/leagueiterations/league`, { params: filter });
    }

    getAvailableByMemberId(memberId: string): any {
        return this.http.get(`${this.url}/leagueiterations/available/member/${memberId}`);
    }

    getById(id: string): any {
        return this.http.get(`${this.url}/leagueiteration/${id}`);
    }

    create(data: any): any {
        return this.http.post(`${this.url}/leagueiteration/create`, data);
    }

    update(id: string, data: any): any {
        return this.http.post(`${this.url}/leagueiteration/update/${id}`, data);
    }

    delete(data: any): any {
        return this.http.post(`${this.url}/leagueiteration/delete`, data);
    }
}

